import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import type { ResponsibleConsultantDropdownOption } from '../../utils/responsibleConsultantOptions';

export interface ResponsibleConsultantSelectProps {
  value: string;
  onChange: (userId: string) => void;
  options: ResponsibleConsultantDropdownOption[];
  loading?: boolean;
  disabled?: boolean;
  placeholder?: string;
  fluid?: boolean;
  style?: React.CSSProperties;
  className?: string;
  onOpen?: () => void;
}

export const ResponsibleConsultantSelect: React.FC<ResponsibleConsultantSelectProps> = ({
  value,
  onChange,
  options,
  loading = false,
  disabled = false,
  placeholder,
  fluid = true,
  style,
  className,
  onOpen,
}) => (
  <Dropdown
    fluid={fluid}
    search
    selection
    scrolling
    selectOnBlur={false}
    selectOnNavigation={false}
    className={className}
    style={style}
    loading={loading}
    disabled={disabled}
    placeholder={
      loading ? 'Carregando consultores...' : placeholder ?? 'Selecione o consultor'
    }
    options={options.map((opt) => ({
      key: opt.key,
      value: opt.value,
      text: opt.text,
    }))}
    value={value || undefined}
    onChange={(_e, data) => onChange(String(data.value ?? ''))}
    onOpen={() => onOpen?.()}
    noResultsMessage="Nenhum consultor encontrado"
  />
);
